/* # Pikaday-based button date picker

  This implementation solves problems associated with
  letting the user type directly into the date field,
  such as the date being potentially invalid or not
  in a format that the server is expecting.
      <div data-hook="datePicker" class="mt-32" data-selected="30 Aug 2020">
        <button data-hook="datePicker.button" type="button">
           <span data-hook="datePicker.display">Sun Aug 30 2020</span>
        </button>
        <div class="w-0 h-0 p-relative overflow-hidden">
          <input type="text" value="2020-08-30" data-hook="datePicker.field">
        </div>
        <div class="h-0 p-relative z-100" role="presentation" data-hook="datePicker.container">
        </div>
        <input type="hidden" name="date" value="" data-hook="datePicker.output">
      </div>

  Hooks:

  - datePicker - The container for the entire date picker in
    which all other hook elements are nested. This has an
    optional data attribute, data-selected, which can set
    the date on Pikaday. This is independent ot the
    pre-rendered content of datePicker.display and
    datePicker.output.
  - datePicker.display - Text where the selected date appears
    (text content must be pre-rendered)
  datePicker.button - Clickable area to open Pikaday
  datePicker.container - Container where Pikaday day selector
    appears (more stable than the option to append it at the
    end of the document)
  datePicker.field - Required by Pikaday, hidden from the user
  datePicker.output - Output in a predictable format for the server
    (value attribute must be prerendered.)

*/

import {
  assignController, selectAll, select, click,
} from '../api/element-manipulation'

import Pikaday from '../api/pikaday'

assignController('datePicker', (element) => {
  console.log('###### datePicker', element)
  const display = select(element, '[data-hook~="datePicker.display"]')
  const button = select(element, '[data-hook~="datePicker.button"]')
  const container = select(element, '[data-hook~="datePicker.container"]')
  const field = select(element, '[data-hook~="datePicker.field"]')
  const output = select(element, '[data-hook~="datePicker.output"]')

  const onSelect = (event) => {
    console.log('onSelect')
    const date = picker.getDate()
    output.value = `${1900 + date.getYear()}-${(1 + date.getMonth()).toString().padStart(2, '0')}-${(date.getDate().toString().padStart(2, '0'))}`
    console.log('output.value', output.value)
    display.textContent = field.value
  }
  const picker = new window.Pikaday({
    field, onSelect, trigger: button, container,
  })
  console.log('picker', picker)
  console.log('window.Pikaday', window.Pikaday)
  if (element.dataset.selected) {
    picker.setDate(new Date(element.dataset.selected))
  }
})
